import { Component } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { DatasearchService } from '../../_services/datasearch.service';
import { AuthenticationService } from '../../_services/authentication.service';
declare var $: any;

@Component({
  selector: 'app-edit-profile',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    CommonModule,
    NgFor,
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
  ],
  templateUrl: './edit-profile.component.html',
  styleUrl: './edit-profile.component.scss',
})
export class EditProfileComponent {
  labels: { profession: string; checked: boolean }[] = [];
  profileForm: FormGroup = this.fb.group({});
  form_initialised = false;
  logo_url = 'https://www.chemrobotics.com/staging/images/users_profile/';
  ids: number[] = [];
  professions: any = [];
  user_data: any = {};
  alertVisible: boolean = false;
  constructor(
    private fb: FormBuilder,
    private datasearch: DatasearchService,
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    this.getLabels();
    this.getUserprofile();
  }

  getLabels() {
    this.datasearch.getUserprofession().subscribe(
      (res) => {
        // this.professions = res.data.map((item: any) => ({  profession: item.profession, checked: false }));
        this.professions = res.data;
        // console.log(this.professions);
        this.getUserprofile();
      },
      (err) => {
        // console.error('Error fetching user profession data', err);
      }
    );
  }
  getUserprofile() {
    const currentUserdata = JSON.parse(
      localStorage.getItem('currentUser') || '{}'
    );

    // Ensure currentUserdata and email are defined
    if (!currentUserdata || !currentUserdata.email) {
      // console.error('User data is missing or email is not available');
      return;
    }

    const email = currentUserdata.email;

    const postdata = {
      keyword: email,
    };

    this.datasearch.getUserprofile(postdata).subscribe(
      (res) => {
        // console.log(res);
        this.user_data = res.data;
        this.initialiseForm(res.data);
        this.professions.forEach((val: any) => {
          res.data.scientific_profession.indexOf(val.id) === -1
            ? ''
            : (val.checked = true);
        });
      },
      (err) => {}
    );
  }

  initialiseForm(data: any) {
    this.profileForm = this.fb.group({
      account_type: [data.account_type],
      address: [data.address, Validators.required],
      company_email_id: ['', [Validators.required, Validators.email]],
      company_name: [data.company_name, Validators.required],
      country_name: [data.country_name, Validators.required],
      department_name: [data.department_name, Validators.required],
      education: [data.education, Validators.required],
      email: [data.email, [Validators.required, Validators.email]],
      industry: [data.industry, Validators.required],
      institute_company: [data.institute_company, Validators.required],
      mobile: [
        data.mobile_no,
        [Validators.required, Validators.pattern('^[0-9]+$')],
      ],
      name: [data.name, Validators.required],
      occupation: [data.occupation, Validators.required],
      pincode: [data.pincode, Validators.required],
      scientific_profession: [[]],
      state: [data.state, Validators.required],
    });

    this.form_initialised = true;
  }

  toggleCheckbox(index: number): void {
    this.professions[index].checked = !this.professions[index].checked;
  }

  // submit_profile_form() {
  //   console.log(this.professions.filter((val:any) => val.checked).map((val:any) => val.id));
  //   const profession_id = this.professions.filter((val:any) => val.checked).map((val:any) => val.id);
  //   this.profileForm.controls['scientific_profession'].setValue(profession_id);
  //   console.log(this.profileForm);
  //   let postdata: any = {};
  //   postdata.data = this.profileForm.value;
  //   console.log(postdata);

  // }

  submit_profile_form() {
    const profession_ids = this.professions
      .filter((val: any) => val.checked)
      .map((val: any) => val.id);
    this.profileForm.controls['scientific_profession'].setValue(profession_ids);

    let postdata: any = this.profileForm.value;
    for (let key in this.user_data) {
      if (!(key in postdata)) {
        postdata[key] = this.user_data[key];
      }
    }
    // console.log(postdata);
    this.datasearch.sendUpdate(postdata).subscribe(
      (response) => {
        this.getLabels();
        this.showSuccessAlert();
      },
      (error) => {
        // console.log(error);
      }
    );
  }
  showSuccessAlert() {
    this.alertVisible = true;
    setTimeout(() => this.closeAlert(), 5000); // Hide alert after 5 seconds
  }

  closeAlert() {
    this.alertVisible = false;
  }
  LogoutClick() {
    this.authenticationService.logout();
    // console.log('Logout clicked');
    this.closeSignoutModal();

    const currentRoute = this.router.url;
    const routesToRedirect = ['/profile', '/edit_profile', '/change_password'];

    if (routesToRedirect.includes(currentRoute)) {
      this.router.navigate(['/home']);
    }
  }
  closeSignoutModal() {
    const modalElement = document.getElementById('signOutModal');
    if (modalElement) {
      $('#signOutModal').modal('hide');
      let backdropElements = document.querySelectorAll('.modal-backdrop');
    }
  }
}
